module.exports = __webpack_public_path__ + "static/media/system-smart.dc601644.svg";